import "../namespace.js";

window.Sparkle ??= {};
window.Sparkle.PatientJourneyManager ??= {};

Sparkle.PatientJourneyManager.PatientDocuments = Sparkle.PatientJourneyManager.PatientDocuments || {};
